import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface MyHrUserTwoFactorCardIsActiveProps {
  twoFactorType: string;
  twoFactorEnabledAt: string;
  userData?: {
    twoFactorEnabledAt?: string;
    [key: string]: any;
  };
}

export const MyHrUserTwoFactorCardIsActive = ({
  twoFactorType,
  twoFactorEnabledAt,
  userData,
}: MyHrUserTwoFactorCardIsActiveProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box>
      <Box display="flex" flexDirection="row">
        <Box width="50%">
          <Typography variant="body1">
            {t("MY_HR_TWO_FACTOR_AUTHENTICATION")}:
          </Typography>
        </Box>
        <Box width="50%">
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.greenBase.main,
            }}
          >
            {t("OC_ACTIVE")}{" "}
            {userData?.twoFactorEnabledAt ? `(${twoFactorEnabledAt})` : ""}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ marginTop: "-4px" }}>
        <Typography variant="caption" sx={{ color: theme.palette.owGray.main }}>
          {t("MY_HR_TWO_FACTOR_AUTHENTICATION_ACTIVE")}
        </Typography>
      </Box>
      <Box height="8px" />
      <Box display="flex" flexDirection="row">
        <Box width="50%">
          <Typography variant="body1">
            {t("MY_HR_TWO_FACTOR_AUTHENTICATION_TYPE")}:
          </Typography>
        </Box>
        <Box width="50%">{twoFactorType}</Box>
      </Box>
    </Box>
  );
};

export default MyHrUserTwoFactorCardIsActive;
